import React, { Component } from 'react';
import About from '../components/About'; 

class AboutContainer extends Component {
	componentWillMount(){
		document.body.scrollTop = document.documentElement.scrollTop = 0;
	}
	componentDidMount(){	 
		setTimeout(function(){
			document.getElementById('menu-besuch').classList.add('active');
		},400);
	}
	render() {		   
		   const { page } = this.props.resolves;
		   return (
				
					<About staticData={this.props.resolves.staticData} {...page} />
			)
	   
	}
}
export default AboutContainer;


// WEBPACK FOOTER //
// ./src/containers/AboutContainer.js